import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = 'Privacy and Policy';

    return () => {
      document.title = 'GEO DEVELOPMENT'; 
    };
  }, []);

  return (
    <section style={{
      padding: '6rem 1.5rem 4rem',
      background: '#f8f9fa',
      minHeight: '100vh',
      color: '#2d3436',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start'
    }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        style={{
          width: '100%',
          maxWidth: '800px',
          background: 'white',
          padding: '3.5rem',
          borderRadius: '20px',
          border: '1px solid rgba(0, 0, 0, 0.08)',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.05)',
          position: 'relative'
        }}
      >
        <div style={{
          position: 'absolute',
          top: '20px',
          left: '20px',
          display: 'flex',
          gap: '8px',
        }}>
          <div style={{
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            background: '#ff6b6b',
          }}></div>
          <div style={{
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            background: '#ffa502',
          }}></div>
          <div style={{
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            background: '#2ecc71',
          }}></div>
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '2.5rem'
        }}>
          <div>
            <Link 
              to="/"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                color: '#0072ff',
                textDecoration: 'none',
                fontSize: '0.95rem',
                fontWeight: '500',
                transition: 'color 0.2s ease',
                marginBottom: '1rem',
                ':hover': {
                  color: '#0056b3'
                }
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '0.5rem' }}>
                <path d="M19 12H5M12 19l-7-7 7-7"/>
              </svg>
              Back to Home
            </Link>

            <h1 style={{
              fontSize: '2.75rem',
              background: 'linear-gradient(90deg, #0072ff, #00c6ff)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: '700',
              marginBottom: '1rem',
              lineHeight: '1.2'
            }}>
              Privacy Policy
            </h1>

            <p style={{ 
              color: '#666',
              fontSize: '0.95rem',
              marginBottom: '0'
            }}>
              Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>

          <div style={{ 
            color: '#4a4a4a', 
            lineHeight: 1.8,
            display: 'flex',
            flexDirection: 'column',
            gap: '2rem'
          }}>
            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                Introduction
              </h2>
              <p>
                GEO DEVELOPMENT is committed to protecting your privacy. This Privacy Policy 
                explains how your personal information is collected, used, and disclosed by GEO DEVELOPMENT.
              </p>
            </section>

            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                Information We Collect
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                We may collect information about you in various ways:
              </p>
              <ul style={{ 
                paddingLeft: '1.5rem',
                listStyleType: 'disc',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
              }}>
                <li>Information you provide to us directly</li>
                <li>Information we collect automatically</li>
                <li>Information from third parties</li>
              </ul>
            </section>

            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                How We Use Information
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                We use your information for various purposes, including:
              </p>
              <ul style={{ 
                paddingLeft: '1.5rem',
                listStyleType: 'disc',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
              }}>
                <li>To provide and maintain our services</li>
                <li>To improve user experience</li>
                <li>To communicate with you</li>
                <li>For security and legal purposes</li>
              </ul>
            </section>

            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                Sharing of Information
              </h2>
              <p>
                We may share information about you in certain circumstances, such as with service providers, 
                for legal reasons, or in connection with business transfers.
              </p>
            </section>

            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                Your Rights and Choices
              </h2>
              <p>
                You have certain rights regarding your personal information, including the right to access, 
                correct, or delete your data. Please contact us for assistance with exercising these rights.
              </p>
            </section>

            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                Security of Information
              </h2>
              <p>
                We implement appropriate technical and organizational measures to protect your personal information.
              </p>
            </section>

            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                Changes to This Privacy Policy
              </h2>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting 
                the new Privacy Policy on this page.
              </p>
            </section>

            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                Contact Us
              </h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us at 
                <a href="mailto:geodevelopment21@gmail.com" style={{ 
                  color: '#0072ff', 
                  marginLeft: '5px', 
                  textDecoration: 'none',
                  fontWeight: '500',
                  transition: 'color 0.2s ease',
                  ':hover': {
                    color: '#0056b3'
                  }
                }}>
                  geodevelopment21@gmail.com
                </a>.
              </p>
            </section>
          </div>
        </div>
      </motion.div>
    </section>
  )
}

export default PrivacyPolicy 